export default {
      id: "icon-line-chart-usage",
      viewBox: "0 0 24 24",
      url: "/assets/img" + "symbol-defs.6e7610.svg#icon-line-chart-usage",
      toString: function () {
        return this.url;
      }
    }